import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/ibm-aiops-training/ibm-aiops-training/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`Topology Pods in Crashloop`}</h2>
    <p>{`If the aiops-topology-xxx Pods are crashlooping, apply the following patches. I have only seen this happen on ROKS.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`
oc patch deployment aiops-topology-merge -n ibm-aiops --patch-file "./ansible/roles/ibm-aiops-install-instance/templates/aiops/patches/aiops-topology-merge-patch.yaml"
oc patch deployment aiops-topology-search -n ibm-aiops --patch-file "./ansible/roles/ibm-aiops-install-instance/templates/aiops/patches/aiops-topology-search-patch.yaml"
oc patch deployment aiops-topology-status -n ibm-aiops --patch-file "./ansible/roles/ibm-aiops-install-instance/templates/aiops/patches/aiops-topology-status-patch.yaml"
oc patch deployment aiops-topology-layout -n ibm-aiops --patch-file "./ansible/roles/ibm-aiops-install-instance/templates/aiops/patches/aiops-topology-layout-patch.yaml"

`}</code></pre>
    <h2>{`Pods with Pull Error`}</h2>
    <p>{`If Pods are having pull errors, apply the following patches. `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`
kubectl patch -n ibm-aiops serviceaccount aiops-topology-service-account -p '{"imagePullSecrets": [{"name": "ibm-entitlement-key"}]}'
kubectl patch -n ibm-aiops serviceaccount aiops-ir-analytics-spark-worker -p '{"imagePullSecrets": [{"name": "ibm-entitlement-key"}]}'
kubectl patch -n ibm-aiops serviceaccount aiops-ir-analytics-spark-pipeline-composer -p '{"imagePullSecrets": [{"name": "ibm-entitlement-key"}]}'
kubectl patch -n ibm-aiops serviceaccount aiops-ir-analytics-spark-master -p '{"imagePullSecrets": [{"name": "ibm-entitlement-key"}]}'
kubectl patch -n ibm-aiops serviceaccount aiops-ir-analytics-probablecause -p '{"imagePullSecrets": [{"name": "ibm-entitlement-key"}]}'
kubectl patch -n ibm-aiops serviceaccount aiops-ir-analytics-classifier -p '{"imagePullSecrets": [{"name": "ibm-entitlement-key"}]}'
kubectl patch -n ibm-aiops serviceaccount aiops-ir-lifecycle-eventprocessor-ep -p '{"imagePullSecrets": [{"name": "ibm-entitlement-key"}]}'
oc delete pod $(oc get po -n ibm-aiops|grep ImagePull|awk '{print$1}') -n ibm-aiops

`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      